<div class="gray-bg-rounded">
  <form [formGroup]="emailForm">
    <p-editor
      #emailEditor
      ngDefaultControl
      formControlName="body"
      id="email-editor"
      [style]="{ height: '200px' }"></p-editor>

    <p-button
      label="Send"
      *ngIf="displaySendButton"
      (click)="send()"
      class="mt-3 d-flex" />

    <!-- <button
      *ngIf="displaySendButton"
      class="btn btn-primary mb-3"
      type="submit"
      (click)="send()">
      
    </button> -->
  </form>
</div>
